const publishingRequests = {
  requestsBreadcrumb: "الطلبات",
  listBreadcrumb: "طلبات النشر",
  pendingTab: "قيد الانتظار",
  pendingTabWithCount: "قيد الانتظار ({count})",
  doneTab: "الطلبات المنتهية",
  searchPlaceholder: "اسم الفعالية / اسم الشركة",
  companyName: "اسم الشركة",
  eventName: "اسم الفعالية",
  requestType: "نوع الطلب",
  feesAmount: "قيمة الرسوم",
  requestDate: "تاريخ الطلب",
  paymentProof: "إثبات الدفع",
  requestStatus: "حالة الطلب",
  amountValue: "{amount} ريال",
  types: {
    publish: "نشر",
    upgrade_size: "تغيير حجم الطاقم",
  },
  statuses: {
    accepted: "مقبول",
    rejected: "مرفوض",
    canceled: "ملغي",
  },
  accept: "قبول",
  reject: "رفض",
  done: "تم",
  filterCompany: "الشركة",
  filterType: "نوع الطلب",
  filterDate: "تاريخ الطلب",
  filterStatus: "حالة الطلب",
  showingRange: "عرض {from}-{to} من {total} طلب",
  emptyPendingTitle: "لا توجد طلبات قيد الانتظار",
  emptyPendingDescription:
    "ستظهر هنا طلبات النشر الجديدة من الشركات لمراجعتها.",
  emptyDoneTitle: "لا توجد طلبات منتهية بعد",
  emptyDoneDescription: "تظهر الطلبات هنا بعد قبولها أو رفضها أو إلغائها.",
  emptyResultsTitle: "لا توجد طلبات",
  emptyResultsDescription: "لا يوجد طلب يطابق البحث أو الفلاتر.",
  clearFilters: "مسح البحث والفلاتر",
  summary: {
    company: "الشركة",
    event: "الفعالية",
    crewFee: "رسوم الطاقم",
    transferEvidence: "إثبات التحويل",
    amountDue: "المبلغ المستحق",
    crewSize: "حجم الطاقم",
    crewSizeValue: "{size} (حتى {max} متقدم)",
    crewSizeRangeValue: "{size} ({min} – {max} متقدم)",
    differenceToPay: "الفرق المطلوب دفعه",
    changeCrewSize: "تغيير حجم الطاقم",
    changeCrewSizeValue: "{from} ← {to}",
  },
  cancelledTitle: "تم إلغاء الطلب",
  cancelledMessage: "ألغت الشركة هذا الطلب، لذا لم يعد بالإمكان قبوله أو رفضه.",
  rejectDescription: "السبب إلزامي وسيتم إرساله بالبريد الإلكتروني إلى الشركة",
  rejectionReason: "سبب الرفض",
  rejectionReasonPlaceholder: "اكتب سبب رفضك لهذا الطلب...",
  rejectionReasonRequired: "سبب الرفض مطلوب",
  publish: {
    acceptTitle: "طلب نشر",
    acceptDescription: "سيتم نشر الفعالية وتحصيل رسوم الطاقم.",
    rejectTitle: "رفض طلب النشر",
    acceptedTitle: "تم نشر الفعالية",
    acceptedMessage: "الفعالية منشورة الآن. تم تسجيل الدفع",
    rejectedToast: "تم رفض طلب النشر.",
  },
  upgrade_size: {
    acceptTitle: "طلب تغيير حجم الطاقم",
    acceptDescription: "سيتم تطبيق حجم الطاقم الجديد وتحصيل الفرق.",
    rejectTitle: "رفض طلب تغيير حجم الطاقم",
    acceptedTitle: "تمت ترقية حجم الطاقم",
    acceptedMessage: "الفعالية الآن على حجم الطاقم {size}.",
    rejectedToast: "تم رفض طلب الترقية.",
  },
};

export default publishingRequests;
